// extracted by mini-css-extract-plugin
export default {"wrapper":"_2AgysIBlq9wq6GgtfihdY_"};